export var de = {
  meta: {
    title: "UgrzejMnie — Brennstoff, Heizung, Klima & Photovoltaik in Polen",
    description: "UgrzejMnie — bestellen Sie Brennstoff (Propan, Pellets, Ökokohle, Gas), Kessel- und Wärmepumpenservice, Klimaanlage oder Photovoltaik. Lokale Techniker antworten, Sie wählen das beste Angebot.",
    ogTitle: "UgrzejMnie — Brennstoff, Service, Klima & PV",
    ogDescription: "Brennstoff, Heizungsservice, Klimaanlage oder Photovoltaik in Minuten bestellen. Lokale Fachleute antworten — Sie wählen das Angebot.",
  },
  nav: {
    skip: "Zum Inhalt springen",
    homeAria: "UgrzejMnie — Startseite",
    aria: "Hauptnavigation",
    home: "Startseite",
    how: "Wie es funktioniert",
    app: "App",
    offer: "Was Sie bestellen",
    service: "Service",
    payments: "Zahlungen",
    trust: "Sicherheit",
    provider: "Für Anbieter",
    fuelProviders: "Für Brennstoffhändler",
    technicians: "Für Servicetechniker",
    more: "Mehr",
    download: "App herunterladen",
    game: "Spiel",
    menu: "Menü",
  },
  lang: {
    label: "Sprache wählen",
  },
  trustBar: {
    label: "Flexible Abrechnung",
    text: "Online-Zahlungen via Stripe, aufgeschobene Klarna-Zahlung (30 Tage) oder Barzahlung bei Lieferung — je nach Angebot des Anbieters.",
  },
  hero: {
    headline: "Brennstoff & Heizungsservice — wenn Sie es brauchen.",
    lead: "Bestellen Sie Propan, Pellets, Gas, Ökokohle, Heizungsservice, Klimaanlage oder Photovoltaik in wenigen Minuten. Lokale Techniker antworten — Sie wählen das Angebot.",
    downloadAndroid: "Für Android herunterladen",
    downloadIos: "Für iPhone herunterladen (demnächst)",
    securityNote: "Sicher in der App bestellen — die Auftragsbestätigung erfordert Ihre ausdrückliche Aktion.",
    forProviders: "Für Anbieter",
    playGame: "Spiel Ugrzej Osiedle",
  },
  how: {
    heading: "Wie es funktioniert",
    sub: "Drei Schritte — von der Anfrage bis zur Lieferung oder dem Service bei Ihnen.",
    step1: {
      title: "Bestellen",
      desc: "Beschreiben Sie Ihren Bedarf — Brennstoff, Heizungsservice, Klimaanlage oder Photovoltaik. Geben Sie Standort und Termin an.",
    },
    step2: {
      title: "Angebote der Techniker",
      desc: "Lokale Anbieter und Techniker antworten in der App. Vergleichen Sie Preise und Termine.",
    },
    step3: {
      title: "Lieferung / Service",
      desc: "Wählen Sie ein Angebot — Brennstoff wird geliefert, der Techniker kommt zum vereinbarten Termin.",
    },
    cluster: {
      kicker: "Brennstoff mit Nachbarn",
      title: "Sammelbestellung — gemeinsame Lieferung",
      desc: "Bestellen Sie Pellets, Kohle oder Gas? Öffnen Sie in der App eine Sammelbestellung und senden Sie den Link an Nachbarn. Bündeln Sie Mengen auf einer Route — oft günstiger als einzelne Fahrten.",
      cta: "In der App öffnen",
    },
  },
  app: {
    heading: "Die App in Aktion",
    sub: "Kunde, Anbieter und Desktop — so sieht UgrzejMnie von innen aus.",
    slide1: "Schnellbestellung",
    slide2: "Servicekatalog",
    slide3: "Angebote & Preise",
    slide4: "Anbieter-Panel",
    slide5: "Ihre Spezialisierungen",
    slide6: "Auftragsangebot",
    slide7: "Auftrags-Desktop",
    slide8: "Schnellangebot",
    prev: "Vorheriger Bildschirm",
    next: "Nächster Bildschirm",
    dots: "Bildschirm wählen",
    dot: "Bildschirm",
  },
  offer: {
    heading: "Was Sie bestellen",
    sub: "Eine App für Brennstoff, Heizung, Klimaanlage und Photovoltaik — ein Fachmann, wenn Sie ihn brauchen.",
    propan: {
      title: "Propan",
      desc: "Tankbefüllung — Lieferung an Ihre Adresse, ohne Anrufe bei Großhändlern.",
    },
    pellet: {
      title: "Pellets & Ökokohle",
      desc: "Saisonale Festbrennstoffbestellungen — vergleichen Sie Angebote lokaler Anbieter.",
    },
    heatpump: {
      title: "Wärmepumpe",
      desc: "Inspektion, Wartung und Reparatur — Techniker mit Erfahrung in Ihrem Heizsystem.",
    },
    solidBoiler: {
      title: "Festbrennstoffkessel",
      desc: "Reinigung, Verbrennungseinstellung, Teileaustausch — Service vor Ort.",
    },
    gas: {
      title: "Gas & LPG",
      desc: "Lieferung und Befüllung von Gastanks, Wartung von Gasheizungen und LPG-Anlagen.",
    },
    electric: {
      title: "Elektroheizung",
      desc: "Inspektionen, Reparaturen und Austausch von Komponenten in häuslichen Elektroheizungsanlagen.",
    },
    ac: {
      title: "Klimaanlage",
      desc: "Wartung, Reinigung und Montage von Klimaanlagen — lokale Techniker mit F-Gas-Zulassung.",
    },
    pv: {
      title: "Photovoltaik",
      desc: "Service von PV-Anlagen sowie Montage oder Erweiterung — Angebote lokaler Installateure.",
    },
  },
  reminders: {
    heading: "Wartung nicht verpassen",
    sub: "Speichern Sie Ihre Heizungsanlage und UgrzejMnie erinnert Sie an den Wartungstermin, bevor die Saison beginnt.",
    step1: {
      title: "Heizraum hinzufügen",
      desc: "Speichern Sie Adresse, Heizungstyp, Kessel- oder Wärmepumpenmodell und Anlagenparameter an einem Ort.",
    },
    step2: {
      title: "Wartungstermin festlegen",
      desc: "Wählen Sie das Datum der nächsten Inspektion. Das System berechnet automatisch, wie viel Zeit bis zum Technikerbesuch bleibt.",
    },
    step3: {
      title: "Erinnerung erhalten",
      desc: "Vor dem Termin erhalten Sie eine Benachrichtigung und können ganz einfach einen Service bei einem vertrauenswürdigen lokalen Fachmann buchen.",
    },
  },
  payments: {
    heading: "Bequeme und sichere Zahlungen für Brennstoff und Service",
    sub: "Auf ugrzejmnie.pl verbinden wir Sie direkt mit lokalen Heizbrennstofflieferanten und Technikern. Die Anbieter legen die akzeptierten Zahlungsmethoden für ihre Angebote fest, sodass Sie die für Sie am besten geeignete Lösung wählen können.",
    klarna: {
      title: "Jetzt kaufen, später bezahlen mit Klarna",
      desc: "Ausgewählte Anbieter bieten flexible Klarna-Ratenzahlungen an. Bestellen Sie Pellets, Ökokohle, Holz oder Gas und sehen Sie die Rückzahlungsbedingungen (einschließlich etwaiger Raten) in Klarna Checkout vor der Bestätigung.",
      note: "Verfügbar bei Anbietern, die Klarna-Zahlungen anbieten",
    },
    stripe: {
      title: "Schnelle und sichere Stripe-Zahlungen",
      desc: "Zahlen Sie sofort per Karte (Visa, Mastercard) oder über andere in Stripe Checkout verfügbare Zahlungsmethoden. Stripe garantiert ein hohes Sicherheitsniveau (PCI-DSS) und Transaktionsbestätigung.",
      note: "Verfügbar bei Anbietern, die Online-Zahlungen unterstützen",
    },
    cash: {
      title: "Barzahlung",
      desc: "Bevorzugen Sie die traditionelle Methode? Viele lokale Anbieter ermöglichen die Barzahlung bei Lieferung oder Serviceerbringung — zum Basispreis des Angebots, ohne Plattformgebühr (0 PLN).",
      note: "Zahlungsdetails finden Sie auf der jeweiligen Angebotskarte",
    },
    promo: {
      title: "Brennstoff für den Winter bestellen, ohne sofort das Budget zu belasten",
      desc: "Suchen Sie auf ugrzejmnie.pl nach Anbietern, die Klarna-Zahlungen anbieten — erhalten Sie Ihren Brennstoff wie vereinbart und begleichen Sie Ihre Rechnung bei Klarna gemäß den in Checkout angezeigten Bedingungen.",
      days: "30",
      daysUnit: "Tage",
    },
  },
  trust: {
    heading: "Vertrauen & Sicherheit",
    sub: "Ihre Daten und Zahlungen sind in jeder Phase geschützt — von der Auftragserteilung bis zur Abrechnung mit dem Anbieter.",
    encryption: {
      title: "Verschlüsselte persönliche Daten",
      desc: "Sensible Daten, wie die Personalausweisnummer bei Brennstofflieferungen, werden verschlüsselt und nur an den ausgewählten Anbieter weitergegeben.",
    },
    certified: {
      title: "Zertifizierte Zahlungen",
      desc: "Online-Zahlungen werden von Stripe mit dem höchsten PCI-DSS Level 1 Sicherheitsstandard verarbeitet. Ihre Kartendaten werden niemals auf unseren Servern gespeichert.",
    },
    marketplace: {
      title: "Lokaler Anbieter-Marktplatz",
      desc: "UgrzejMnie verbindet Sie mit vertrauenswürdigen Technikern und Anbietern in Ihrer Nähe. Vertrag und Ausführung bleiben zwischen Ihnen und dem gewählten Fachmann.",
    },
    notifications: {
      title: "Auftragsstatusbenachrichtigungen",
      desc: "Sie erhalten Benachrichtigungen über neue Angebote, Statusänderungen und bevorstehende Wartungen, damit Sie nichts verpassen.",
    },
  },
  provider: {
    heading: "UgrzejMnie-Anbieter werden",
    sub: "Erreichen Sie Kunden, die in Ihrer Region Brennstoff, Heizungsservice, Klimaanlage oder Photovoltaik benötigen. Verwalten Sie Angebote, Zahlungen und Aufträge von Ihrem Telefon und Desktop — in einem Ökosystem.",
    benefitMixedRoute: {
      title: "Gemischte Routen A+B & Tageskurs",
      desc: "Kombinieren Sie Plattformaufträge mit eigenen Kunden auf einem LKW. Fügen Sie eigene Lieferungen für eine geringe Gebühr von 0,5% (min. 3 PLN) hinzu. Automatische Routenoptimierung und Ladekapazitätskontrolle.",
    },
    benefitDriverManifest: {
      title: "Fahrer ohne App, digitale WZ & Offline",
      desc: "Keine App-Installation und kein Login. Der Fahrer scannt morgens 1 QR-Code: Google Maps-Navigation, Barzahlung, digitale Unterschriften mit Steuerbefreiung und Nachbuchung von Unterwegs auch ohne Internet.",
    },
    benefit1: {
      title: "Flexible Zahlungen und transparente Provisionen",
      desc: "Sie entscheiden, ob Sie Barzahlung, Online-Zahlung (Stripe, Karte) oder Klarna akzeptieren. Plattformprovisionen sind bei jedem Angebot sichtbar, und Sie erhalten Gelder direkt vom Kunden.",
    },
    benefit2: {
      title: "Aufträge per WhatsApp",
      desc: "Sie müssen die App nicht ständig überwachen. Aktivieren Sie WhatsApp-Benachrichtigungen und neue Aufträge in Ihrer Nähe gehen direkt auf Ihr Telefon. Geben Sie ein Angebot mit einem Klick über einen dedizierten, sicheren Link ab — ohne Anmeldung im Panel.",
    },
    benefit3: {
      title: "Desktop-App",
      desc: "Arbeiten Sie am Schreibtisch? Laden Sie die Windows-, macOS- oder Linux-Version herunter und verwalten Sie Aufträge vom Computer. Die vollständige Kontoverwaltung verbleibt in der mobilen App, damit sensible Einstellungen sicher sind.",
    },
    benefit4: {
      title: "Ihren Servicebereich festlegen",
      desc: "Sie entscheiden, wie weit Sie fahren. Stellen Sie einen Radius von 10 bis 200 km ein — Änderungen synchronisieren sich automatisch zwischen der mobilen App und dem Desktop.",
    },
    benefit5: {
      title: "Abonnement und Abrechnung an einem Ort",
      desc: "Verwalten Sie Ihr Abonnement, Auszahlungsmethoden und Provisionshistorie über den Profil-Tab. Alles transparent und sofort nach dem Einloggen verfügbar.",
    },
    benefit6: {
      title: "Sammelbestellungen — vollere Touren",
      desc: "Kunden bündeln Brennstofflieferungen in einer Sammelbestellung. Sie erhalten mehrere Stopps auf einer gemeinsamen Route und kalkulieren sie gemeinsam statt einzelner Fahrten.",
    },
    promo: {
      kicker: "Aktion für Techniker",
      title: "Der erste Serviceauftrag ist kostenlos",
      desc: "Kein Auftrag — keine Gebühr. Sie sehen Anfragen und können ohne Abonnement anbieten. Ab dem zweiten abgeschlossenen Auftrag (Wärmepumpen, Kessel, Heizung, Klima, PV) gilt die Kategoriegebühr. Brennstofflieferungen bleiben unverändert.",
    },
    pricing: {
      kicker: "Preise für Anbieter",
      title: "Beispielhafte Plattformtarife",
      disclaimer:
        "Dies ist eine Beispielpreisliste. Tarife können nach Kontakt individuell vereinbart werden.",
      commissionsTitle: "Provisionen auf Brennstofflieferungen",
      subsTitle: "Service-Abonnements (30 Tage)",
      loading: "Preisliste wird geladen…",
      error: "Preisliste konnte nicht geladen werden.",
      cta: "Individuelles Angebot anfragen",
      cat: {
        heat_pumps: "Wärmepumpen-Service",
        boilers: "Kessel- und Ofenservice",
        installations: "Heizungsinstallations-Service",
        ac: "Klimaanlage (Service & Montage)",
        pv: "Photovoltaik und Energiespeicher",
      },
    },
    mobileApp: "Mobile App",
    apiBadge: "Für ERP / TMS / WMS Systeme",
    apiTitle: "Nahtlose API- & Webhook-Integration",
    apiDesc: "Nutzen Sie ein eigenes ERP-, TMS- oder Warenwirtschaftssystem (z.B. Subiekt, Optima, SAP)? Empfangen Sie Anfragen, übermitteln Sie Angebote und Bestätigungen mit digitaler Unterschrift zu 100% automatisch über unsere REST-API und Webhooks.",
    apiTag1: "Automatische Aufträge",
    apiTag2: "Echtzeit-Webhooks",
    apiTag3: "API-Schlüssel & HMAC",
    apiCta: "Integrator-Portal öffnen (API Docs)",
    gatewayFuelTitle: "Brennstoffhändler & Lager",
    gatewayFuelDesc: "Gemischte Route A+B (0,5%), 1 Fahrer-QR-Code, digitale e-WZ und transparenter Tarif.",
    gatewayTechTitle: "Installateure & Servicetechniker",
    gatewayTechDesc: "Wärmepumpen (F-Gase), Heizkessel, Klimaanlagen, kostenloser Testlauf (1. Auftrag gratis).",
    desktopTitle: "Desktop-App",
    desktopNote: "Die vollständige Konto-, Spezialisierungs- und Abonnementverwaltung verbleibt in der mobilen App — damit sensible Einstellungen und Berechtigungen auf Ihrem Telefon unter Kontrolle bleiben. Der Desktop enthält nur das Nötigste für die komfortable Büroarbeit: Auftragsbenachrichtigungen und schnelle Angebote.",
    formTitle: "Mit uns verkaufen",
    formSubtitle: "Füllen Sie das kurze Formular aus und wir melden uns",
    fieldName: "Vor- und Nachname / Firmenname",
    fieldNamePlaceholder: "z.B. Max Müller / Gas-Bau GmbH",
    fieldEmail: "E-Mail",
    fieldEmailPlaceholder: "ihre@email.de",
    fieldPhone: "Telefonnummer",
    fieldPhonePlaceholder: "+48 600 700 800",
    fieldCity: "Stadt und Servicegebiet",
    fieldCityPlaceholder: "z.B. Krakau und Umgebung bis 30 km",
    fieldServices: "Angebotene Dienste / Produkte",
    servicePropan: "Propan",
    servicePellet: "Pellets / Ökokohle",
    serviceBoiler: "Kessel-/Pumpenwartung",
    serviceAc: "Klimaanlage",
    servicePv: "Photovoltaik",
    fieldNotes: "Zusätzliche Informationen (optional)",
    fieldNotesPlaceholder: "Erzählen Sie uns kurz über Ihr Unternehmen...",
    consent: "Ich stimme der Verarbeitung meiner personenbezogenen Daten gemäß der",
    consentPrivacy: "Datenschutzrichtlinie",
    consentPurpose: "zur Bearbeitung dieser Anfrage und für den geschäftlichen Kontakt zu.",
    captchaLabel: "Anti-Spam-Verifizierung",
    captchaLoading: "Frage wird geladen...",
    captchaRefresh: "Frage aktualisieren",
    captchaPlaceholder: "Antwort eingeben",
    submit: "Anfrage senden",
    sending: "Wird gesendet...",
    instructWin: "<strong>Anleitung (Windows):</strong> Laden Sie den <code>.exe</code>-Installer herunter und starten Sie ihn. Das Programm installiert sich automatisch und fügt eine Desktop-Verknüpfung hinzu.",
    instructMac: "<strong>Anleitung (macOS):</strong> Laden Sie die <code>.dmg</code>-Datei herunter (wählen Sie Apple Silicon für neue Macs mit M1/M2/M3/M4-Chips oder Intel für ältere Modelle). Öffnen Sie sie und ziehen Sie die App in den Ordner Programme.",
    instructLinux: "<strong>Anleitung (Linux):</strong> Wir empfehlen das <code>.deb</code>-Paket (Symbol und Systemmenü). Wenn Sie die <code>AppImage</code>-Version verwenden, markieren Sie die Datei nach dem Herunterladen als ausführbar (<code>chmod +x</code>) und wählen Sie im Dateimanager &bdquo;Als Programm ausführen erlauben&ldquo;.",
    loadingVersions: "Versionen werden geladen…",
    refreshVersions: "Versionsliste aktualisieren",
    errorNoAssets: "Keine Installationsdateien in der neuesten Version gefunden.",
    errorLoad: "Die Versionsliste konnte nicht abgerufen werden. Bitte versuchen Sie es später erneut.",
    currentVersion: "Aktuelle Version:",
    draft: "(Entwurf)",
    seeDownloads: "Download-Bereich anzeigen",
    warningWin: "Die App wird derzeit im Microsoft Store überprüft. Wenn Windows vor der Ausführung eine Warnung anzeigt, klicken Sie auf <em>\"Weitere Informationen\"</em> und dann auf <em>\"Trotzdem ausführen\"</em>. Wir versichern Ihnen, dass das Programm völlig sicher ist.",
  },
  b2bFuel: {
    trustBar: "Gemischte Route A+B (0,5% min. 3 PLN) · 1 Fahrer-QR-Manifest · Digitale e-WZ mit Unterschrift & Verbrauchssteuer-ID.",
    badge: "Logistik-Ökosystem für Brennstoffhändler & Lager",
    headline: "Mehr Aufträge auf der Route und keine Papier-Lieferscheine mehr.",
    lead: "Kombinieren Sie Ihre eigenen Direktkunden mit Marktplatzaufträgen von UgrzejMnie auf einem Lkw. Geben Sie dem Fahrer 1 täglichen QR-Code, erfassen Sie digitale e-WZ-Liefernachweise und arbeiten Sie 100% offline.",
    btnRegister: "Lager registrieren",
    btnPricing: "Preise ansehen",
    btnPdf: "PDF herunterladen (2 S. A4)",
    featuresHeadline: "Wie UgrzejMnie Ihr Brennstofflager optimiert?",
    featuresLead: "Entwickelt speziell für Brennstoffhändler, Tankwagenfahrer und Steuerprüfungen.",
    cardMixedRouteTitle: "Gemischte Route A+B",
    cardMixedRouteDesc: "Haben Sie feste Direktkunden? Tragen Sie deren Aufträge (Stream B) für eine minimale Gebühr von 0,5% (min. 3 PLN, max. 5 PLN) ein und nehmen Sie Marktplatzaufträge (Stream A) mit. Keine Leerfahrten mehr.",
    cardMixedRouteBadge: "Gemeinsame Nutzlast & TSP",
    cardQrTitle: "Tagesroute & QR-Manifest",
    cardQrDesc: "Der Fahrer scannt morgens 1 QR-Code. Die Stopp-Reihenfolge wird ab Ihrem Lager automatisch optimiert mit 1-Klick-Google-Maps-Navigation.",
    cardQrBadge: "Keine App-Installation nötig",
    cardEwzTitle: "Digitale e-WZ & Verbrauchssteuerschutz",
    cardEwzDesc: "Pflichtangabe von Ausweisdaten, Steuerbefreiungserklärung, digitale Unterschrift des Kunden auf dem Smartphone, GPS-Zeitstempel und 1-Klick-CSV-Export für Finanzbehörden.",
    cardEwzBadge: "Steuerschutz",
    cardOfflineTitle: "100% Offline & Spontanabladungen",
    cardOfflineDesc: "Kein LTE-Empfang auf dem Land? Das gesamte Manifest, Belege und Unterschriften funktionieren offline. Der Fahrer kann auch unterwegs Spontanaufträge erfassen.",
    cardOfflineBadge: "Outbox Sync",
    cardAdjustTitle: "Automatische Mengenanpassung",
    cardAdjustDesc: "Bei Tankwagenlieferungen: Wenn weniger als bestellt in den Tank passt, erstattet das System die Differenz sofort auf die Karte (Stripe Connect).",
    cardAdjustBadge: "Keine Streitigkeiten",
    cardApiTitle: "Offene Integrator-API",
    cardApiDesc: "Verbinden Sie UgrzejMnie direkt mit Ihrem ERP/TMS (Subiekt, Symfonia, SAP). Aufträge und Angebote fließen über sichere Webhooks.",
    cardApiBadge: "REST + Webhooks",
    puescBadge: "Verfügbar — PUESC-Integration",
    puescHeadline: "SENT und e-DD direkt von der Route — automatisch ans Finanzministerium",
    puescLead: "Das PUESC-Modul läuft in der Anbieter-App und am Desktop. SENT- (Transport-) und e-DD- (Verbrauchsteuer-) Erklärungen entstehen aus der Routenabwicklung und werden mit qualifizierter Signatur unterzeichnet — ohne manuelle Eingabe ins e-Finanzamt.",
    puescSoon: "Verfügbar",
    puescSentTitle: "SENT — Transporterklärungen",
    puescSentDesc: "Automatische Transportmeldungen für Verbrauchsteuerwaren an das Elektronische Transportüberwachungssystem. Routen-, Fahrzeug- und Fahrerdaten werden direkt aus dem Tageskurs übernommen — keine doppelten Einträge im e-Finanzamt.",
    puescEddTitle: "e-DD — Elektronische Lieferscheine",
    puescEddDesc: "Elektronische Lieferscheine für brennsteuerpflichtigen Brennstoff, unterzeichnet mit qualifiziertem XAdES-Zertifikat. Werden automatisch aus dem e-WZ nach Kundenbestätigung generiert — mit PESEL-Nummer, GPS-Stempel und Verbrauchsteuererklärung.",
    puescCtaTitle: "SENT und e-DD in Ihrem Lager einschalten",
    puescCtaDesc: "Das PUESC-Modul ist in den Plänen Pro und Enterprise enthalten. Wählen Sie ein Flottenpaket oder schreiben Sie uns — wir rollen es auf Ihren Routen aus.",
    puescCtaBtn: "Flottenpakete ansehen",
    lpgSentBadge: "SENT für LPG-/Autogas-Stationen",
    lpgSentHeadline: "Eine Route — drei SENT-Abschlusswege mit der Station",
    lpgSentLead: "LPG-Autogas-Lieferungen an Tankstellen erfordern SENT-100 und SENT-103 mit Zählerständen. UgrzejMnie unterscheidet eigene Stationen (gleiche NIP) von fremden und unterstützt den RecipientKey (KR-…) — ohne Login der Station in Ihr PUESC-Konto.",
    lpgPathOwnKicker: "1 · Eigene NIP",
    lpgPathOwnTitle: "Eigene Station / dieselbe Firma",
    lpgPathOwnDesc: "Nach dem Entladen erfasst der Fahrer die Zählerstände. Das System schließt SENT-103 in PUESC für den Lieferanten (STANDARD) — ohne KR-Schlüssel.",
    lpgPathKrKicker: "2 · Fremde NIP + KR",
    lpgPathKrTitle: "Franchise / Partnerstation mit RecipientKey",
    lpgPathKrDesc: "Die Station hinterlegt KR-… einmal (E-Mail-Portal oder Katalog). Nach der Lieferung schließen Sie SENT-103 in ihrem Namen: offizielle SENT-Nummer + RecipientKey + Zählerstände.",
    lpgPathExtKicker: "3 · Fremde NIP ohne KR",
    lpgPathExtTitle: "Station schließt selbst in PUESC",
    lpgPathExtDesc: "E-Mail mit Referenz, dann offizielle SENT-Nummer und Zählerstände. Die Station schließt SENT-103 auf ihrem Konto; der Disponent bestätigt im Desktop (CONFIRMED_EXTERNALLY).",
    lpgSentBullet1: "Zwei Stations-Mails: nach Registrierung (Referenz) und nach Vergabe der offiziellen SENT-Nummer durch PUESC.",
    lpgSentBullet2: "Stationsportal (Magic-Link) zur einmaligen Eingabe des RecipientKey — ohne Konto in Ihrer App.",
    lpgSentBullet3: "Zählerstände von der Route; Korrektur vor externer Bestätigung möglich.",
    lpgSentDocBtn: "SENT-Leitfaden LPG-Stationen (HTML / PDF-Druck)",
    lpgSentContactBtn: "Über Stationseinsatz sprechen",
    lpgSentLegal: "Wie beim gesamten PUESC-Modul: Meldepflichten und SISC-Rechte bleiben beim Lieferanten. Das Tool ersetzt weder das PUESC-Konto der Station noch steuerliche Entscheidungen.",
    pricingKicker: "Preise für Brennstoffhändler",
    pricingHeadline: "Provision nur für neue Aufträge + Flotten-Abonnement",
    pricingLead: "0% Provision für Ihre eigenen Stammkunden (Stream B). Sie zahlen eine Erfolgsprovision nur dann, wenn wir Ihnen einen neuen Kunden vermitteln.",
    streamATitle: "Marktplatz-Aufträge (Stream A)",
    streamADesc: "Für über UgrzejMnie vermittelte Bestellungen von Hausbesitzern und Unternehmen in Ihrer Region.",
    streamARate: "0,5% – 1,0%",
    streamANote: "Erfolgsprovision nur für abgeschlossene Bestellungen",
    streamBTitle: "Eigene Direktaufträge (Stream B)",
    streamBDesc: "Für Stammkunden Ihres Lagers aus Telefon, Hof oder Excel-Import. 0% Verkaufsprovision.",
    streamBRate: "0 PLN (0% Provision)",
    streamBNote: "0 PLN Provision auf den Verkauf Ihres Brennstoffs und eigene Kunden",
    monthlyInvoiceTitle: "Eine monatliche B2B-Sammelrechnung",
    monthlyInvoiceDesc: "Marktplatz-Provisionen (Stream A) und optionale Flottenabonnements (Plan Pro / Enterprise per B2B-Rechnung) werden monatlich mit 14 Tagen Zahlungsziel abgerechnet. Eigene Direktaufträge (Stream B) sind zu 0 PLN (0%) enthalten.",
    zeroHiddenFees: "0 PLN versteckte Kosten",
    puescLoading: "Preise für Abos werden geladen…",
    puescError: "Preise nicht verfügbar — kontaktieren Sie uns.",
    puescKicker: "Flotten-Abonnements & Werkzeuge",
    puescPlansHeadline: "Wählen Sie das passende Paket für Ihre Flotte",
    puescPlansLead: "Basic-Plan ohne Fixkosten (nur Provision bei Neukunden aus Stream A) oder Pro / Enterprise mit PUESC-Modul (SENT und e-DD). Aktionspreise gültig bis Ende 2026.",
    puescNote: "Abo-Preise netto. Aktionsangebot bis Ende 2026. Basic-Plan immer 0 PLN/Monat und 0% Provision für eigene Direktkunden (Stream B).",
    pdfTitle: "Leitfaden für Brennstoffhändler herunterladen (PDF)",
    pdfDesc: "Komplette 2-seitige A4-Übersicht: traditionelles Lager vs. UgrzejMnie-Ökosystem, QR-Manifest und Kostenersparnis.",
    formHeadline: "Benötigen Sie individuelle Unterstützung?",
    formLead: "Sie können sofort starten, indem Sie die App oben herunterladen. Wenn Sie eine größere Flotte betreiben — hinterlassen Sie Ihre Kontaktdaten.",
    formSubmit: "Anfrage senden",
  },
  b2bTech: {
    trustBar: "Kostenloser Testlauf — 1. abgeschlossener Auftrag 100% gratis · Digitaler Servicebericht · Aufträge in Ihrem Landkreis.",
    badge: "B2B-Bereich für Installateure & Servicetechniker",
    headline: "Mehr Aufträge in Ihrem Landkreis und sichere Abrechnung.",
    lead: "Erhalten Sie direkte Anfragen von Hausbesitzern für Wärmepumpen-Wartung (F-Gase), Heizkessel, Klimaanlagen und Photovoltaik. 1. Auftrag 100% ohne Provision und ohne Abo!",
    btnJoin: "App herunterladen & beitreten",
    btnPricing: "Preise & Testlauf",
    btnPdf: "PDF herunterladen",
    featuresHeadline: "Welche Aufträge warten bei UgrzejMnie auf Sie?",
    featuresLead: "Wir verbinden Sie mit Hausbesitzern genau in Ihrem gewünschten Arbeitsradius.",
    pricingKicker: "Preise für Servicetechniker",
    pricingHeadline: "Kostenloser Testlauf und flexible Landkreis-Abonnements",
    pricingLead: "Transparente Konditionen ohne versteckte Gebühren. Zahlen Sie nur für gewünschte Regionen.",
    trialTitle: "Willkommenspaket (Free First Job)",
    trialDesc: "Für jeden neu registrierten Fachbetrieb und Servicetechniker.",
    trialRate: "0 PLN",
    trialNote: "Erster erledigter Auftrag 100% provisions- und abofrei",
    subsTitle: "Service-Abonnement (30 Tage)",
    subsDesc: "Aktiviert nach Abschluss des kostenlosen Testauftrags.",
    subsRate: "39 – 49 PLN / 30 Tage",
    subsNote: "0% Provision auf den Servicewert bei aktivem Abonnement",
    pdfTitle: "Leitfaden für Servicetechniker herunterladen (PDF)",
    pdfDesc: "Erfahren Sie alle Kooperationsdetails: Auftragsvergabe, digitale Protokolle und Rentabilität.",
    formHeadline: "Benötigen Sie Hilfe bei der Einrichtung?",
    formLead: "Sie können sich direkt in der App registrieren. Wenn Sie Fragen haben oder ein größeres Team vertreten — hinterlassen Sie Ihre Kontaktdaten.",
    formSubmit: "Kontaktanfrage senden",
  },
  faq: {
    heading: "Häufig gestellte Fragen",
    sub: "Ein kurzer Leitfaden zu UgrzejMnie — bevor Sie die App herunterladen.",
    q1: "Was ist UgrzejMnie?",
    a1: "Eine App, die Sie mit lokalen Brennstofflieferanten und Technikern für Heizung, Klimaanlage und Photovoltaik verbindet. Stellen Sie eine Anfrage, erhalten Sie Angebote und wählen Sie das passende aus.",
    q2: "Welche Leistungen werden unterstützt?",
    a2: "In der App können Sie Brennstoff und Service für Festbrennstoffkessel (Pellets, Ökokohle), LPG- und Propantanks, Gasheizungen, Wärmepumpen und Elektroheizungen bestellen sowie Service und Montage von Klimaanlagen und Photovoltaikanlagen.",
    q3: "Erinnert mich die App an eine bevorstehende Wartung?",
    a3: "Ja. Sie können Ihre Heizungsanlage mit dem Datum der nächsten Wartung speichern. UgrzejMnie sendet Ihnen eine Vorbenachrichtigung, damit Sie rechtzeitig den richtigen Techniker buchen können.",
    q4: "Wer liefert Brennstoff und führt den Service durch?",
    a4: "Unabhängige Anbieter und Techniker aus Ihrer Region. UgrzejMnie ist ein Marktplatz — wir verbinden die Parteien, aber Vertrag und Ausführung werden direkt zwischen Ihnen und dem gewählten Fachmann vereinbart.",
    q5: "Welche Zahlungsmethoden sind auf ugrzejmnie.pl verfügbar?",
    a5: "Die verfügbaren Methoden hängen vom Angebot ab. Sie können <strong>bar beim Fahrer (COD)</strong> zum Basispreis zahlen (0 PLN Plattformgebühr) oder eine <strong>geschützte Online-Zahlung</strong> (Karte, BLIK, P24 oder Klarna) mit dem Sicherheitszahlungspaket wählen — Stripe-Autorisierung, bargeldlose Abwicklung und priorisierte Reklamationsunterstützung. Die Servicegebühr wird vor der Bestätigung angezeigt und verbleibt beim Betreiber; der Anbieter erhält den Basispreis.",
    q6: "Wie prüfe ich, welche Zahlungen ein Anbieter akzeptiert?",
    a6: "Die akzeptierten Zahlungsmethoden sind immer deutlich auf der jeweiligen Angebotskarte bei der Auftragserteilung oder Angebotsanfrage sichtbar.",
    q7: "Wie funktioniert die Klarna-Ratenzahlung für Brennstoff?",
    a7: "Wenn Ihr gewählter Anbieter Klarna-Zahlungen unterstützt, können Sie Brennstoff mit der Option &bdquo;Jetzt kaufen, später bezahlen&rdquo; bestellen (Klarna-Bedingungen werden in Checkout angezeigt). Sie erhalten die Lieferung wie mit dem Anbieter vereinbart und begleichen Ihre Rechnung bei Klarna gemäß deren Bedingungen.",
    q8: "Sind Online-Zahlungen auf ugrzejmnie.pl sicher?",
    a8: "Ja. Digitale Zahlungen werden über das zertifizierte Zahlungs-Gateway von Stripe abgewickelt, das den höchsten internationalen PCI-DSS Level 1 Sicherheitsstandard erfüllt. Keine Kartendaten werden auf ugrzejmnie.pl gespeichert.",
    q9: "Gibt es eine iPhone-App?",
    a9: "Die Kunden- und Anbieter-Apps sind derzeit für Android verfügbar. Die iOS-Version befindet sich in der Entwicklung und wird bald verfügbar sein.",
    q10: "Funktioniert es in meiner Region?",
    a10: "Angebote kommen von lokalen Anbietern. Je mehr Techniker in Ihrer Region vorhanden sind, desto schneller erhalten Sie Antworten. Laden Sie die App herunter und prüfen Sie die Verfügbarkeit in Ihrer Nähe.",
    q11: "Warum kann bei einer Brennstofflieferung eine ID-Nummer erforderlich sein?",
    a11: "Bei Brennstofflieferungen (flüssig, fest, LPG, Flaschen) kann die Plattform eine nationale ID-Nummer für die Dokumentation des Anbieters anfordern. Die Nummer wird nur an den zugewiesenen Anbieter weitergegeben und nicht für Marketing verwendet — Details finden Sie in der Datenschutzrichtlinie.",
    q12: "Ich bin Techniker — wie fange ich an?",
    a12: "Laden Sie die mobile Anbieter-App herunter, vervollständigen Sie Ihr Profil und Ihre Spezialisierungen. Techniker starten ohne Abonnement: der erste abgeschlossene Serviceauftrag (Wärmepumpen, Kessel, Heizung, Klima, PV) ist kostenlos — ab dem zweiten gilt die Kategoriegebühr. Sie können auch Stammkunden per Link oder QR-Code einladen. Für die Büroarbeit können Sie die Desktop-App hinzufügen (Windows, macOS, Linux) — Details im Bereich Für Anbieter.",
    q13: "Wozu dient die Desktop-App für Anbieter?",
    a13: "Der Desktop ist eine praktische Ergänzung am Schreibtisch: Auftragsbenachrichtigungen und schnelle Angebote. Die vollständige Konto-, Spezialisierungs- und Abonnementverwaltung verbleibt in der mobilen App — damit sensible Einstellungen auf Ihrem Telefon unter Kontrolle bleiben.",
    q14: "Warum erfolgt die Bestellung über die App und nicht über ein Web-Formular?",
    a14: "Die mobile App dient als Sicherheitsebene für den gesamten Marktplatz. Sie schützt Anbieter und Kunden vor gefälschten Bestellungen, ermöglicht sofortige Push-Benachrichtigungen (für Angebote, Lieferzeiten und Bestätigungen) und baut ein verifiziertes Vertrauensprofil auf — was ein einfaches Web-Formular nicht leisten kann.",
    q15: "Was ist eine Brennstoff-Sammelbestellung?",
    a15: "Eine gemeinsame Lieferung mit Nachbarn. Sie öffnen in der App eine Sammelbestellung, senden Link oder Code, und Nachbarn treten mit eigener Menge desselben Brennstoffs und derselben Verpackung bei. Der Anbieter fährt eine Route — oft günstiger als einzelne Fahrten.",
  },
  footer: {
    tagline: "Brennstoff & Heizungsservice — wenn Sie es brauchen.",
    facebook: "Folgen Sie uns auf Facebook",
    toTop: "Nach oben",
    contact: "Kontakt",
    navigation: "Navigation",
    navAria: "Schnelllinks",
    legal: "Informationen",
    legalAria: "Rechtliche Informationen",
    privacy: "Datenschutzrichtlinie",
    terms: "Nutzungsbedingungen",
    apiDocs: "Integrator-Portal (API)",
    pdfFuel: "Vorteile für Lieferanten (PDF)",
    pdfLpgSent: "SENT LPG-Stationen (Leitfaden)",
    forProviders: "Für Brennstoffhändler",
    forTechnicians: "Für Servicetechniker",
    copyright: "© 2026 UgrzejMnie · HelpMeNow Prosta S.A. Alle Rechte vorbehalten.",
    companyName: "HelpMeNow Prosta S.A.",
    address: "ul. Wspólna 2, 96-330 Mrozy, Polen",
    registry: "KRS 0001127133 · NIP 8381887256 · REGON 529645405",
    phone: "+48 690 355 556",
  },
  cookie: {
    text: "Unsere Website verwendet Cookies, die für den ordnungsgemäßen Betrieb notwendig sind, einschließlich der Speicherung von Einstellungen. Weitere Informationen finden Sie in unserer",
    privacyLink: "Datenschutzrichtlinie",
    accept: "Verstanden",
  },
};
